import { UseMutationResult, useMutation } from '@tanstack/react-query'
import { gql } from 'graphql-request'

import { useGraphQLClient } from '@/hooks/useGraphQLClient'

import { AddressPoint, addressPointFragment } from './useAddressPointApi'

export interface DeleteAddressPointResult {
  addressPoint: AddressPoint | null
  errors: { field: string; message: string }[]
  message: string
  success: boolean
}

export const useDeleteAddressPointApi = (): UseMutationResult<
  DeleteAddressPointResult,
  Error,
  string
> => {
  const client = useGraphQLClient()

  const query = gql`
    mutation DeleteAddressPoint($id: ID!) {
      deleteAddressPoint(id: $id) {
        addressPoint {
          ...addressPoint
        }
        errors {
          field
          message
        }
        message
        success
      }
    }
    ${addressPointFragment}
  `

  const mutationFn = (id: string): Promise<DeleteAddressPointResult> =>
    client
      .request<{ deleteAddressPoint: DeleteAddressPointResult }>(query, { id })
      .then(({ deleteAddressPoint }) => deleteAddressPoint)

  return useMutation<DeleteAddressPointResult, Error, string>({ mutationFn })
}
